import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        const currentYear = new Date().getFullYear();

        return (
            <footer className="footer footer-center flex flex-col items-center px-4 py-12 space-y-4 text-base lg:text-xl">
                <aside>
                    <p><a href="https://www.pynovate.com">Pynovate Studio</a> &copy; 2022-{currentYear}. All rights reserved.</p>
                </aside>
            </footer>
        )
    }
}